module.exports = __webpack_public_path__ + "img/logo_no_shadow.0e308f7b.png";